import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { getUserProfileSelector, showToast, useAppSelector } from 'store';
import * as Yup from 'yup';
import { CustomButton, FormTextField } from 'components/shared';
import { CustomModal } from 'components/shared/CustomModal';
import { RadabankService } from 'utils/services';
import { IUserProfileResponse } from 'utils/types';
import styles from './styles.module.scss';

const validationSchema = Yup.object().shape({
	email: Yup.string().email('Некоректний email').required('Обовʼязкове поле'),
});

interface Props {
	isOpen: boolean;
	onClose: () => void;
	transaction: any;
}

export const EmailReceiptModal: FC<Props> = ({ isOpen, onClose, transaction }) => {
	const dispatch = useDispatch();
	const profile = useAppSelector(getUserProfileSelector);

	const methods = useForm<{ email: string }>({
		defaultValues: { email: '' },
		resolver: yupResolver(validationSchema),
	});

	const { handleSubmit, formState } = methods;

	const onSubmit = async (values: { email: string }) => {
		try {
			const operid = transaction?.operid || transaction?.operidret;
			const finalDocId = operid ? transaction?.docid : transaction?.id;

			await RadabankService.printEmailClientPayment({
				userId: (profile as IUserProfileResponse).userId,
				operid,
				docid: finalDocId,
				emailrec: values.email,
			});

			dispatch(showToast({ message: 'Квитанцію відправлено!', color: 'success' }));
			onClose();
		} catch (error: any) {
			dispatch(showToast({ message: error?.message || 'Помилка відправки' }));
		}
	};

	return (
		<CustomModal isOpen={isOpen} onClose={onClose} title="Введіть email">
			<FormProvider {...methods}>
				<form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
					<FormTextField name="email" label="Email" type="email" />

					<CustomButton className="mt-4" label="Відправити" type="submit" disabled={formState.isSubmitting} />
				</form>
			</FormProvider>
		</CustomModal>
	);
};
